import { useEffect, useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import BitCompanion from "@/components/bit/BitCompanion";
import { getAdsConfig } from "@/components/AdBanner";
import { Loader2, Coffee } from "lucide-react";

export default function AppLayout() {
  const { user } = useAuth();
  const [sponsored, setSponsored] = useState(null);

  useEffect(() => {
    // AdSense Script dynamisch laden auf Seiten mit echtem Inhalt
    const scriptId = "adsense-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.async = true;
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4005237431516670";
      script.crossOrigin = "anonymous";
      document.head.appendChild(script);
    }

    getAdsConfig().then((cfg) => {
      if (cfg?.enabled && cfg.smartlink_url) {
        setSponsored({ url: cfg.smartlink_url, label: cfg.smartlink_label || "Sponsored" });
      }
    });
  }, []);

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-10 w-10 animate-spin text-primary" strokeWidth={2.2} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-6xl mx-auto w-full px-4 sm:px-6 pt-8 pb-36">
        <Outlet />
      </main>
      <footer className="border-t border-line bg-background/80 py-5 text-center text-xs font-medium text-muted-foreground">
        <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} DevPath – Programmieren lernen, spielerisch.</span>
          <div className="flex items-center gap-4">
            <a
              href="https://www.buymeacoffee.com/kaidrabot"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="buy-me-a-coffee-link"
              className="flex items-center gap-1.5 rounded-lg border border-warning/50 px-3 py-1.5 text-warning hover:bg-warning/10"
            >
              <Coffee className="h-3.5 w-3.5" strokeWidth={2.2} />
              Kaffee spendieren
            </a>
            {sponsored && (
              <>
                <a
                  href={sponsored.url}
                  target="_blank"
                  rel="noopener noreferrer sponsored"
                  data-testid="sponsored-link"
                  className="hover:text-foreground underline"
                >
                  {sponsored.label}
                </a>
                <span className="text-muted-foreground/40">|</span>
              </>
            )}
            <Link to="/impressum" className="hover:text-foreground transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="hover:text-foreground transition-colors">
              Datenschutz
            </Link>
            <a
              href="mailto:kontakt@kaidra.app"
              className="hover:text-foreground transition-colors"
            >
              Kontakt
            </a>
          </div>
        </div>
      </footer>
      {user && <BitCompanion />}
    </div>
  );
}
